import type { MouseEvent } from "react";

import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { PlainTooltip, Type } from "@similarweb/ui-components";

import { StyledItemIcon } from "./styles";

type Props = {
    imgSrc: string;
    companyName: string;
    tooltipContent: IPlainTooltipProps["tooltipContent"];
    companyOverviewLink: string;
    onCompanyLinkClick?(): void;
};

const CompanyNameWithLinkCell = ({
    imgSrc,
    companyName,
    tooltipContent,
    companyOverviewLink,
    onCompanyLinkClick,
}: Props) => {
    const handleCompanyLinkClick = (e: MouseEvent): void => {
        e.stopPropagation();
        onCompanyLinkClick?.();
    };

    return (
        <>
            <StyledItemIcon
                iconType={Type.Website}
                iconSrc={imgSrc}
            />

            <div className="swTable-content-large text">
                <PlainTooltip tooltipContent={tooltipContent}>
                    <a
                        href={companyOverviewLink}
                        rel="noreferrer"
                        target="_blank"
                        onClick={handleCompanyLinkClick}
                    >
                        <span
                            className="website-block"
                            data-automation="company-name"
                        >
                            {companyName}
                        </span>
                    </a>
                </PlainTooltip>
            </div>
        </>
    );
};

export default CompanyNameWithLinkCell;
